"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5306],{

/***/ 12234:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/about-us-bg-min-7c5f45da.1221708e.png","height":258,"width":600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAABlBMVEVcXFxMaXFIrgZzAAAAAnRSTlMBAG+I/HkAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAOSURBVHicY2BAA4xwAgAAKgADeQH0GAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 93114:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/app-store-3d6c31a5.4f374497.png","height":58,"width":185,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAJ1BMVEUSEhIdHR0rKysxMTEgICAPDw9CQkJAQEBHR0cqKio+Pj5+fn64uLhMYH53AAAACHRSTlPe39XT1erZ1WbhieYAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAgSURBVHicY2BgZAABVgYebk4OLg4uTgY2ZhZ2JiZmRgAFRQBwkBUe9wAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 48357:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/google-play-06118c77.2644d154.png","height":58,"width":185,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAJ1BMVEUpLCwGBwcQDAwbHBsBAQEAAAASEhI6OjoiIiI8PDxFRUU4MCVMe2v/Ww9sAAAACXRSTlPW5tDR5u/n0ecAD2WKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAI0lEQVR4nGNgZeRgY2RhYWXg4ebk5OLk5GJgYGJmYGdmYgAAB5gAg5T8zecAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 73475:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/hero-three-bg-481f9e8a.bdadb03e.png","height":859,"width":753,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAElBMVEX48d/58Ofl7tzv7e7y7eP27dseJz2wAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALElEQVR4nC3KwQkAMAzDQDm291+5NO1LcAjiIUZABZ5eYX61Wt4nVmuQWuUADuUAfjBWlFoAAAAASUVORK5CYII=","blurWidth":7,"blurHeight":8});

/***/ }),

/***/ 43796:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/phone-large-629241ae.a94957bd.png","height":661,"width":327,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAMAAADp7a43AAAASFBMVEW+v72MjoZvdmxjbFaIpa5ZPIawpr+Uloi3ubWirLGTjnTKy8ViemvCu7xVYGLX3uzr6+hSOXqupbucmpq+u6GZjFaQZzv04tytZ1qwAAAAEHRSTlPW6eX089z8/fr9/uT55vP+AzkwzgAAAAlwSFlzAAALEwAACxMBAJqcGAAAACtJREFUeJwFwYUBACAAwKDZ3fX/pwJmDENor5DPregdNL73hIpO4vwSYCcfHqgBV2ExN88AAAAASUVORK5CYII=","blurWidth":4,"blurHeight":8});

/***/ }),

/***/ 48145:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/phone-small-1c94a266.91068ce4.png","height":585,"width":290,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAMAAADp7a43AAAATlBMVEUnIiqYlJI/ImpPR0NBQ0KPj4uJiXzS0tSfmImMZz5KLXB6Zkn17+27u7uyoZi8klx1bm6lo5/+//86Il8yGFfHs6Ld1dZLSkDSwLTo4+LaTIcJAAAAEXRSTlP23Nbq69Lv7/393/r++fX+69XOhGYAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAuSURBVHicBcEHAsAQAACxo7Vq1eb/H5XwtS5xDvB5vcRwftKeD6ZWgx1WI0pRFx38AYE7yhrvAAAAAElFTkSuQmCC","blurWidth":4,"blurHeight":8});

/***/ }),

/***/ 44826:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CarouselNavigator; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/left-icon-black.icon.js


function LeftArrowBlackIcon() {
    return (react.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M11.04 7.5L7.29 11.25V12.3L11.04 16.05L12.105 15L9.645 12.525H18V11.025H9.645L12.12 8.55L11.04 7.5Z", fill: "#2D2D2D" })));
}


//# sourceMappingURL=left-icon-black.icon.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/classnames/index.js
var classnames = __webpack_require__(87637);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Molecules/CarouselNavigator.js




function CarouselNavigator(_a) {
    var classes = _a.classes, onPrevClick = _a.onPrevClick, onNextClick = _a.onNextClick;
    return (react.createElement("div", { className: (0,classnames/* default */.Z)('carousel-navigator', classes) },
        react.createElement("div", { onClick: function () { return onPrevClick === null || onPrevClick === void 0 ? void 0 : onPrevClick(); }, className: "carousel-navigator__left" },
            react.createElement(LeftArrowBlackIcon, null)),
        react.createElement("div", { onClick: function () { return onNextClick === null || onNextClick === void 0 ? void 0 : onNextClick(); }, className: "carousel-navigator__right" },
            react.createElement(LeftArrowBlackIcon, null))));
}


//# sourceMappingURL=CarouselNavigator.js.map


/***/ }),

/***/ 25895:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CarouselProgressIndicator; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87637);



function CarouselProgressIndicator(_a) {
    var classes = _a.classes, slides = _a.slides, position = _a.position;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('carousel-progress-indicator', classes) }, slides.map(function (_, index) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('carousel-progress__dot', {
            'carousel-progress__dot--active': index === position
        }), key: index })); })));
}


//# sourceMappingURL=CarouselProgressIndicator.js.map


/***/ }),

/***/ 43106:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AboutUsOne; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87637);
/* harmony import */ var _assets_about_us_bg_min_7c5f45da_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12234);
/* harmony import */ var _Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93791);
/* harmony import */ var _Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87427);
/* harmony import */ var _Atoms_Button_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66693);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26793);








function AboutUsOne(_a) {
    var classes = _a.classes, image = _a.image, description = _a.description, _b = _a.backgroundImage, backgroundImage = _b === void 0 ? _assets_about_us_bg_min_7c5f45da_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z : _b, onReadMoreClick = _a.onReadMoreClick, imageComponent = _a.imageComponent;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)().t;
    var handleReadMoreClick = function () {
        onReadMoreClick && onReadMoreClick();
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { style: { backgroundImage: "url(".concat(backgroundImage, ")") }, className: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('about-us-one', classes) },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "about-us-one__container" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "about-us-one__image-container" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { src: image, alt: t('landingScreen.aboutUs'), classes: "about-us-one__image", imageComponent: imageComponent })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "about-us-one__content" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { classes: "about-us-one__content__title", variant: 'displayText' }, t('landingScreen.aboutUs')),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { classes: "about-us-one__content__description", variant: 'bodyTextOne' }, description),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Button_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, { classes: "about-us-one__read-more-button", onClick: handleReadMoreClick, variant: 'link', size: 'md' }, t('landingScreen.readMore'))))));
}


//# sourceMappingURL=AboutUsOne.js.map


/***/ }),

/***/ 86190:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AboutUsThree; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87637);
/* harmony import */ var _Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93791);
/* harmony import */ var _Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87427);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26793);
/* harmony import */ var _Atoms_Button_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66693);
/* harmony import */ var _assets_item_card_placeholder_0f7c213a_jpg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44813);








function AboutUsThree(_a) {
    var classes = _a.classes, _b = _a.firstImage, firstImage = _b === void 0 ? _assets_item_card_placeholder_0f7c213a_jpg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z : _b, _c = _a.secondImage, secondImage = _c === void 0 ? _assets_item_card_placeholder_0f7c213a_jpg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z : _c, description = _a.description, onKnowMoreClick = _a.onKnowMoreClick, imageComponent = _a.imageComponent;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)().t;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('about-us-three', classes) },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "about-us-three__left" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { src: firstImage, alt: "About Us Image", classes: "about-us-three__first-image", imageComponent: imageComponent }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { src: secondImage, alt: "About Us Image", classes: "about-us-three__second-image", imageComponent: imageComponent })),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "about-us-three__right" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { classes: "about-us-three__title", variant: 'displayText' }, t('landingScreen.aboutUs')),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { classes: "about-us-three__description", variant: 'bodyTextOne' }, description),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Button_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { classes: "about-us-three__button--mobile", onClick: onKnowMoreClick, variant: 'link', size: 'md' }, t('landingScreen.knowMore')),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Button_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { classes: "about-us-three__button--desktop", onClick: onKnowMoreClick, variant: 'solid', size: 'md' }, t('landingScreen.knowMore')))));
}


//# sourceMappingURL=AboutUsThree.js.map


/***/ }),

/***/ 99457:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AppPromoSection; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87637);
/* harmony import */ var _Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87427);
/* harmony import */ var _assets_google_play_06118c77_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48357);
/* harmony import */ var _assets_app_store_3d6c31a5_png__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93114);
/* harmony import */ var _assets_phone_large_629241ae_png__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43796);
/* harmony import */ var _assets_phone_small_1c94a266_png__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48145);
/* harmony import */ var _Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93791);









function AppPromoSection(_a) {
    var classes = _a.classes, title = _a.title, description = _a.description, availableOnAndroid = _a.availableOnAndroid, availableOnIOS = _a.availableOnIOS, phoneImage = _a.phoneImage, phoneLargeImage = _a.phoneLargeImage, onAndroidClick = _a.onAndroidClick, onIOSClick = _a.onIOSClick, imageComponent = _a.imageComponent;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('app-promo-section', classes) },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "app-promo-section__left" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { classes: "app-promo-section__title", variant: "displayText" }, title),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { classes: "app-promo-section__description", variant: "bodyTextOne" }, description),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "app-promo-section__left__stores" },
                availableOnAndroid ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, { src: _assets_google_play_06118c77_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, alt: "Download from Google Play", classes: "app-promo-section__left__stores__image", onClick: onAndroidClick, imageComponent: imageComponent })) : null,
                availableOnIOS ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, { src: _assets_app_store_3d6c31a5_png__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, alt: "Download from App Store", classes: "app-promo-section__left__stores__image", onClick: onIOSClick, imageComponent: imageComponent })) : null)),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "app-promo-section__right" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "app-promo-section__phone-screens" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, { src: phoneImage || _assets_phone_small_1c94a266_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, alt: "Phone Small", classes: "app-promo-section__right__small--image" }),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, { src: phoneLargeImage || _assets_phone_large_629241ae_png__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, alt: "Phone Large", classes: "app-promo-section__right__large--image", imageComponent: imageComponent })))));
}


//# sourceMappingURL=AppPromoSection.js.map


/***/ }),

/***/ 13871:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FeaturedDishOne; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87637);
/* harmony import */ var _Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87427);
/* harmony import */ var _Atoms_Button_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66693);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26793);
/* harmony import */ var _Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93791);
/* harmony import */ var _assets_item_card_placeholder_0f7c213a_jpg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44813);








function FeaturedDishOne(_a) {
    var classes = _a.classes, description = _a.description, items = _a.items, viewMoreClickCallback = _a.viewMoreClickCallback, onItemClickCallback = _a.onItemClickCallback, backgroundImage = _a.backgroundImage, title = _a.title, imageComponent = _a.imageComponent;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)().t;
    var handleItemClick = function (item) {
        onItemClickCallback === null || onItemClickCallback === void 0 ? void 0 : onItemClickCallback(item);
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { style: backgroundImage
            ? {
                background: " linear-gradient(\n          rgba(0, 0, 0, 0.8),\n          rgba(0, 0, 0, 0.8)\n        ) , url(".concat(backgroundImage, ")"),
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover'
            }
            : { backgroundColor: '#000' }, className: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('featured-dishes-one', classes) },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { classes: "featured-dishes-one__title", variant: 'displayText' }, title ? title : t('landingScreen.featuredDishes')),
        description ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { classes: "featured-dishes-one__description", variant: 'headingTwo', weight: "normal" }, description)) : null,
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "featured-dishes-one__item-list" }, items.map(function (item, index) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "featured-dishes-one__item", key: index, onClick: function () { return handleItemClick(item); } },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { classes: "featured-dishes-one__item-image", src: (item === null || item === void 0 ? void 0 : item.image_url) || _assets_item_card_placeholder_0f7c213a_jpg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, alt: (item === null || item === void 0 ? void 0 : item.item_title) || '', imageComponent: imageComponent }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { classes: "featured-dishes-one__item-name", variant: 'headingThree', weight: "semibold" }, item === null || item === void 0 ? void 0 : item.item_title))); })),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Button_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { onClick: function () {
                viewMoreClickCallback === null || viewMoreClickCallback === void 0 ? void 0 : viewMoreClickCallback();
            }, classes: "featured-dishes-one__button", variant: "solid", size: "lg" }, t('landingScreen.viewMenu'))));
}


//# sourceMappingURL=FeaturedDishOne.js.map


/***/ }),

/***/ 4336:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FeaturedDishThree; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87637);
/* harmony import */ var _Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93791);
/* harmony import */ var _Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87427);
/* harmony import */ var _Atoms_Button_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66693);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26793);
/* harmony import */ var _assets_item_card_placeholder_0f7c213a_jpg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44813);








function FeaturedDishThree(_a) {
    var classes = _a.classes, description = _a.description, onOrderNowClick = _a.onOrderNowClick, _b = _a.image, image = _b === void 0 ? _assets_item_card_placeholder_0f7c213a_jpg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z : _b, title = _a.title, imageComponent = _a.imageComponent;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)().t;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('featured-dish-three', classes) },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "featured-dish-three__left" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { classes: "featured-dish-three__title", variant: 'displayText' }, title ? title : t('landingScreen.featuredDish')),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { classes: "featued-dish-three__description", variant: 'bodyTextOne' }, description),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Button_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { onClick: onOrderNowClick, size: "md", classes: "featured-dish-three__order-now--mobile", variant: 'link' }, t('landingScreen.orderNow')),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Button_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { onClick: onOrderNowClick, size: "md", classes: "featured-dish-three__order-now--desktop", variant: 'solid' }, t('landingScreen.orderNow'))),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { classes: "featured-dish-three__right", alt: "featured dish", src: image, imageComponent: imageComponent })));
}


//# sourceMappingURL=FeaturedDishThree.js.map


/***/ }),

/***/ 71702:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FeaturedDishTwo; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87637);
/* harmony import */ var _Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93791);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26793);
/* harmony import */ var _Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87427);
/* harmony import */ var _Atoms_Button_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66693);







function FeaturedDishTwo(_a) {
    var classes = _a.classes, description = _a.description, onOrderNowClick = _a.onOrderNowClick, image = _a.image, imageComponent = _a.imageComponent, title = _a.title;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$)().t;
    var handleOrderNowClick = function () {
        onOrderNowClick && onOrderNowClick();
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('featured-dishes-two', classes) },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "featured-dishes-two__item-section" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { variant: "displayText", classes: "featured-dishes-two__title" }, title ? title : t('landingScreen.featuredDish')),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { classes: "featured-dishes-two__item-description", variant: "bodyTextOne" }, description),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Button_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { size: "lg", variant: "solid", classes: "featured-dishes-two__cta", onClick: handleOrderNowClick }, t('landingScreen.orderNow'))),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { classes: "featured-dishes-two__item-image", src: image, alt: "featured dish", imageComponent: imageComponent }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Button_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { variant: "link", size: "lg", classes: "featured-dihes-two__mobile__cta", onClick: handleOrderNowClick }, t('landingScreen.readMore'))));
}


//# sourceMappingURL=FeaturedDishTwo.js.map


/***/ }),

/***/ 13813:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HeroOne; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87637);
/* harmony import */ var _Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87427);
/* harmony import */ var _Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93791);





function HeroOne(_a) {
    var classes = _a.classes, title = _a.title, backgroundImage = _a.backgroundImage, logo = _a.logo, locationSearch = _a.locationSearch, imageComponent = _a.imageComponent;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { style: {
            backgroundImage: "url(".concat(backgroundImage, ")")
        }, className: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('hero-one', classes) },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "hero-one__content" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { src: logo, alt: "hero-logo", classes: "hero-one__logo", imageComponent: imageComponent }),
            title ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { weight: "semibold", classes: "hero-one__title", variant: 'headingTwo' }, title)) : null,
            locationSearch ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "hero-one__location-search" }, locationSearch)) : null)));
}


//# sourceMappingURL=HeroOne.js.map


/***/ }),

/***/ 85388:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HeroThree; }
});

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(36929);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/classnames/index.js
var classnames = __webpack_require__(87637);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/hero-three-bg-481f9e8a.png
var hero_three_bg_481f9e8a = __webpack_require__(73475);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/LazyImage.js
var LazyImage = __webpack_require__(93791);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Typography.js
var Typography = __webpack_require__(87427);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/offer-discount.icon.js


function OfferDiscountIcon() {
    return (react.createElement("svg", { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M19.8367 18.7754C18.9034 18.7754 18.1367 19.5421 18.1367 20.4754C18.1367 21.4087 18.9034 22.1754 19.8367 22.1754C20.8034 22.1754 21.5367 21.4087 21.5367 20.4754C21.5367 19.5421 20.7701 18.7754 19.8367 18.7754Z", fill: "#CB202D" }),
        react.createElement("path", { d: "M12.1688 13.4753C13.1021 13.4753 13.8688 12.742 13.8688 11.8086C13.8688 10.8753 13.1021 10.1086 12.1688 10.1086C11.2021 10.1086 10.4688 10.842 10.4688 11.7753C10.4688 12.7086 11.2354 13.4753 12.1688 13.4753Z", fill: "#CB202D" }),
        react.createElement("path", { d: "M30.9685 14.5086L29.8018 12.7753C29.7018 12.5753 29.6685 12.3753 29.6685 12.142L29.8018 10.042C29.8685 8.84196 29.2352 7.74196 28.1685 7.20863L26.3018 6.27529C26.1018 6.17529 25.9685 6.04196 25.8685 5.84196L24.9352 3.97529C24.4018 2.90863 23.2685 2.27529 22.1018 2.34196L20.0018 2.47529C19.8018 2.47529 19.5685 2.44196 19.4018 2.30863L17.6685 1.17529C16.6685 0.508626 15.4018 0.508626 14.4018 1.17529L12.6685 2.34196C12.4352 2.44196 12.2352 2.47529 12.0018 2.47529L9.90182 2.34196C8.70182 2.27529 7.60182 2.90863 7.06849 3.97529L6.13516 5.84196C6.03516 6.04196 5.90182 6.17529 5.70182 6.27529L3.83516 7.20863C2.76849 7.74196 2.13516 8.87529 2.20182 10.042L2.33516 12.142C2.33516 12.342 2.30182 12.5753 2.16849 12.742L1.03516 14.4753C0.36849 15.4753 0.36849 16.7753 1.03516 17.742L2.20182 19.4753C2.30182 19.7086 2.33516 19.9086 2.33516 20.142L2.20182 22.242C2.13516 23.442 2.76849 24.542 3.83516 25.0753L5.70182 26.0086C5.90182 26.1086 6.03516 26.2753 6.13516 26.442L7.06849 28.3086C7.60182 29.3753 8.73516 30.0086 9.90182 29.942L12.0018 29.8086C12.2018 29.8086 12.4352 29.842 12.6018 29.9753L14.3352 31.1086C14.8352 31.442 15.4018 31.6086 15.9685 31.6086C16.5352 31.6086 17.1018 31.442 17.6018 31.1086L19.3352 29.942C19.5018 29.842 19.7352 29.7753 19.9352 29.7753L22.0352 29.9086C23.2352 29.9753 24.3352 29.342 24.8685 28.2753L25.8018 26.4086C25.9018 26.2086 26.0352 26.0753 26.2352 25.9753L28.1018 25.042C29.1685 24.5086 29.8018 23.3753 29.7352 22.2086L29.6685 20.142C29.6685 19.942 29.7018 19.7086 29.8352 19.542L30.9685 17.7753C31.6352 16.7753 31.6352 15.4753 30.9685 14.5086ZM12.1685 8.07529C14.2018 8.07529 15.8685 9.74196 15.8685 11.7753C15.8685 13.8086 14.2018 15.4753 12.1685 15.4753C10.1018 15.4753 8.46849 13.842 8.46849 11.7753C8.46849 9.74196 10.1352 8.07529 12.1685 8.07529ZM10.3352 23.1753C10.1352 23.3753 9.86849 23.4753 9.63515 23.4753C9.40182 23.4753 9.13515 23.3753 8.93515 23.1753C8.53515 22.8086 8.53515 22.1753 8.93515 21.7753L21.6685 9.07529C22.0352 8.67529 22.6685 8.67529 23.0685 9.07529C23.4352 9.47529 23.4352 10.1086 23.0352 10.4753L10.3352 23.1753ZM19.8352 24.2086C17.8018 24.2086 16.1352 22.542 16.1352 20.5086C16.1352 18.4753 17.8018 16.8086 19.8352 16.8086C21.9018 16.8086 23.5352 18.442 23.5352 20.5086C23.5352 22.542 21.8685 24.2086 19.8352 24.2086Z", fill: "#CB202D" })));
}


//# sourceMappingURL=offer-discount.icon.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Button.js
var Button = __webpack_require__(66693);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(21845);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Organisms/HeroThree.js











function HeroThree(_a) {
    var classes = _a.classes, title = _a.title, subTitle = _a.subTitle, subTitleColor = _a.subTitleColor, description = _a.description, locationSearch = _a.locationSearch, _b = _a.backgroundImage, backgroundImage = _b === void 0 ? hero_three_bg_481f9e8a/* default */.Z : _b, featuredImage = _a.featuredImage, mobileFeaturedImage = _a.mobileFeaturedImage, offers = _a.offers, logoImage = _a.logoImage, onOffersReadMoreClick = _a.onOffersReadMoreClick, imageComponent = _a.imageComponent;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var OfferIcon = function (props) { return (react.createElement(Icon/* default */.Z, (0,tslib_es6/* __assign */.pi)({}, props, { component: OfferDiscountIcon }))); };
    return (react.createElement("div", { className: (0,classnames/* default */.Z)({
            'hero-three__wrapper': !(offers === null || offers === void 0 ? void 0 : offers.length)
        }) },
        react.createElement("div", { style: {
                backgroundImage: "url(".concat(backgroundImage, ")")
            }, className: (0,classnames/* default */.Z)('hero-three', classes) },
            react.createElement("div", { className: "hero-three__content__wrapper" },
                react.createElement("div", { className: "hero-three__content" },
                    react.createElement("div", { className: "hero-three__heading" },
                        logoImage ? (react.createElement(LazyImage/* default */.Z, { classes: "hero-three__logo-img", src: logoImage, alt: "logo-image", imageComponent: imageComponent })) : null,
                        react.createElement(Typography/* default */.Z, { classes: "hero-three__title", variant: 'headingOne' }, title),
                        react.createElement(Typography/* default */.Z, { classes: "hero-three__sub-title", variant: 'displayText', color: subTitleColor, weight: "normal" }, subTitle)),
                    react.createElement(Typography/* default */.Z, { classes: "hero-three__description", variant: 'bodyTextOne' }, "\"".concat(description, "\"")),
                    locationSearch ? (react.createElement("div", { className: "hero-three__location-search" }, locationSearch)) : null)),
            react.createElement(LazyImage/* default */.Z, { classes: "hero-three__featured-img--desktop", src: featuredImage || mobileFeaturedImage, alt: "featured-image", imageComponent: imageComponent })),
        react.createElement("div", { className: "hero-three__offers__wrapper" }, (offers === null || offers === void 0 ? void 0 : offers.length) ? (react.createElement("div", { className: "hero-three__offers" }, offers.map(function (offer) { return (react.createElement("div", { className: "hero-three__offers__card" },
            react.createElement(OfferIcon, { className: "offer__icon" }),
            react.createElement(Typography/* default */.Z, { classes: "offer__title", variant: "bodyTextTwoMain" }, offer.title),
            react.createElement(Typography/* default */.Z, { classes: "offer__description", variant: "bodyTextOne" }, offer.description),
            react.createElement(Button/* default */.Z, { onClick: onOffersReadMoreClick, size: "md", variant: "link", classes: "offer__button" }, t('landingScreen.readMore')))); }))) : null)));
}


//# sourceMappingURL=HeroThree.js.map


/***/ }),

/***/ 63687:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HeroTwo; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87427);
/* harmony import */ var _Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93791);




function HeroTwo(_a) {
    var title = _a.title, subTitle = _a.subTitle, backgroundImage = _a.backgroundImage, locationSearch = _a.locationSearch, logo = _a.logo, imageComponent = _a.imageComponent;
    var linearGradient = "linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4))";
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "hero_parent" },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "hero_clipPath", style: {
                backgroundImage: "".concat(linearGradient, ", url(").concat(backgroundImage, ")")
            } },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "hero_clipPath__inner" })),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "hero" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "hero__left" },
                logo ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { src: logo, alt: "hero-logo", classes: "hero-two__logo", imageComponent: imageComponent })) : null,
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "hero__title" },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { variant: "headingOne" }, title)),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "hero__sub_title" },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { variant: "headingTwo" }, subTitle)),
                locationSearch ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "hero__search" }, locationSearch)) : null),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "hero__right" }))));
}


//# sourceMappingURL=HeroTwo.js.map


/***/ }),

/***/ 87880:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HowItWorksThree; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87637);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26793);
/* harmony import */ var _Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87427);
/* harmony import */ var _Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93791);






function HowItWorksThree(_a) {
    var classes = _a.classes, _b = _a.values, values = _b === void 0 ? [] : _b, title = _a.title, imageComponent = _a.imageComponent;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$)().t;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('how-it-works', classes) },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { classes: 'how-it-works__heading', variant: 'displayText' }, title ? title : t('landingScreen.howItWorks')),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "how-it-works__cards" }, values === null || values === void 0 ? void 0 : values.map(function (value) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { title: value.description, className: "how-it-works__card" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { classes: "how-it-works__card__icon", src: value.icon, alt: value.label, imageComponent: imageComponent }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { classes: "how-it-works__card__title", variant: 'headingOne' }, value.label),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { classes: "how-it-works__card__description", variant: 'bodyTextOne' }, value.description))); }))));
}


//# sourceMappingURL=HowItWorksThree.js.map


/***/ }),

/***/ 22477:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LandingScreenMenu; }
});

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(36929);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/classnames/index.js
var classnames = __webpack_require__(87637);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Typography.js
var Typography = __webpack_require__(87427);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Button.js
var Button = __webpack_require__(66693);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/LazyImage.js
var LazyImage = __webpack_require__(93791);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/item-card-placeholder-0f7c213a.jpg
var item_card_placeholder_0f7c213a = __webpack_require__(44813);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Components/Organisms/LandingScreenMenu/Web/item-card.component.js





function ItemCard(_a) {
    var _b = _a.image_url, image_url = _b === void 0 ? item_card_placeholder_0f7c213a/* default */.Z : _b, item_desc = _a.item_desc, item_title = _a.item_title, onClick = _a.onClick, imageComponent = _a.imageComponent;
    return (react.createElement("div", { onClick: onClick, className: "landing-screen-menu__item-card" },
        react.createElement("div", { className: "landing-screen-menu__item-card__image-wrapper" },
            react.createElement(LazyImage/* default */.Z, { src: image_url || item_card_placeholder_0f7c213a/* default */.Z, alt: item_title, classes: "landing-screen-menu__item-card__image", imageComponent: imageComponent })),
        react.createElement("div", { className: "landing-screen-menu__item-card__content" },
            react.createElement(Typography/* default */.Z, { classes: "landing-screen-menu__item-card__title", variant: "headingOne" }, item_title),
            react.createElement(Typography/* default */.Z, { classes: "landing-screen-menu__item-card__description", variant: "bodyTextOne" }, item_desc))));
}


//# sourceMappingURL=item-card.component.js.map

;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Organisms/LandingScreenMenu.js








function LandingScreenMenu(_a) {
    var classes = _a.classes, menu = _a.menu, onViewMenuClick = _a.onViewMenuClick, onItemClick = _a.onItemClick, description = _a.description, title = _a.title, imageComponent = _a.imageComponent;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var handleItemClick = function (item) {
        onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(item);
    };
    return (react.createElement("div", { className: (0,classnames/* default */.Z)('landing-screen-menu', classes) },
        react.createElement(Typography/* default */.Z, { variant: "displayText", classes: "landing-screen-menu__title" }, title ? title : t('landingScreen.ourMenu')),
        react.createElement(Typography/* default */.Z, { variant: "bodyTextOne", classes: "landing-screen-menu__description" }, description),
        react.createElement("div", { className: "landing-screen-menu__cards" }, menu.map(function (item) { return (react.createElement(ItemCard, (0,tslib_es6/* __assign */.pi)({}, item, { key: item.id, onClick: function () { return handleItemClick(item); }, imageComponent: imageComponent }))); })),
        react.createElement(Button/* default */.Z, { variant: "solid", size: "md", classes: "landing-screen-menu__view-menu-button", onClick: onViewMenuClick }, t('landingScreen.viewMenu'))));
}


//# sourceMappingURL=LandingScreenMenu.js.map


/***/ }),

/***/ 11454:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OurMenuSectionTwo; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87637);
/* harmony import */ var _Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87427);
/* harmony import */ var _Atoms_Button_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66693);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26793);
/* harmony import */ var _assets_item_card_placeholder_0f7c213a_jpg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44813);
/* harmony import */ var _Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93791);








function OurMenuSectionTwo(_a) {
    var classes = _a.classes, items = _a.items, description = _a.description, onViewMenuClick = _a.onViewMenuClick, onItemClickCallback = _a.onItemClickCallback, title = _a.title, imageComponent = _a.imageComponent;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)().t;
    var handleItemClick = function (item) {
        onItemClickCallback === null || onItemClickCallback === void 0 ? void 0 : onItemClickCallback(item);
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('our-menu-section-two', classes) },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { variant: "displayText", weight: "bold", classes: "our-menu-section-two__title" }, title ? title : t('landingScreen.ourMenu')),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { variant: "bodyTextOne", classes: "our-menu-section-two__description" }, description),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "our-menu-section-two__item-container" }, items === null || items === void 0 ? void 0 : items.map(function (item) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuItem, { item: item, handleItemClick: handleItemClick, imageComponent: imageComponent })); })),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Button_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { classes: "our-menu-section-two__cta", onClick: onViewMenuClick, variant: "solid", size: "lg" }, t('landingScreen.viewMenu'))));
}
var MenuItem = function (_a) {
    var _b, _c;
    var item = _a.item, handleItemClick = _a.handleItemClick, imageComponent = _a.imageComponent;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "our-menu-section-two__menu-item", onClick: function () { return handleItemClick(item); } },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, { classes: "our-menu-section-two__item-image", src: (item === null || item === void 0 ? void 0 : item.image_url) || _assets_item_card_placeholder_0f7c213a_jpg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, alt: item === null || item === void 0 ? void 0 : item.item_title, imageComponent: imageComponent }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "our-menu-section-two__item-detail-container" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { variant: "headingTwo", classes: "our-menu-section-two__item-name" }, ((_b = item === null || item === void 0 ? void 0 : item.item_title) === null || _b === void 0 ? void 0 : _b.length) > 15
                ? (item === null || item === void 0 ? void 0 : item.item_title.slice(0, 15)) + '...'
                : item === null || item === void 0 ? void 0 : item.item_title),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { classes: "our-menu-section-two__item-description", variant: "bodyTextOne" }, ((_c = item === null || item === void 0 ? void 0 : item.item_desc) === null || _c === void 0 ? void 0 : _c.length) > 80
                ? (item === null || item === void 0 ? void 0 : item.item_desc.slice(0, 80)) + '...'
                : item === null || item === void 0 ? void 0 : item.item_desc))));
};


//# sourceMappingURL=OurMenuSectionTwo.js.map


/***/ }),

/***/ 5684:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TestimonialThree; }
});

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(36929);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/classnames/index.js
var classnames = __webpack_require__(87637);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Typography.js
var Typography = __webpack_require__(87427);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/LazyImage.js
var LazyImage = __webpack_require__(93791);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/comma.icon.js


function CommaIcon() {
    return (react.createElement("svg", { width: "28", height: "57", viewBox: "0 0 38 67", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M37.0977 66.3083L0.200182 66.1274L0.379195 29.6079L15.3187 0.420736L33.7118 0.510897L18.8465 29.6984L37.2767 29.7887L37.0977 66.3083Z", fill: "black" })));
}


//# sourceMappingURL=comma.icon.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(21845);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Components/Organisms/TestimonialThree/Web/testimonial-three-card.component.js







function TestimonialThreeCard(_a) {
    var name = _a.name, designation = _a.designation, quote = _a.quote, image = _a.image, ratings = _a.ratings, imageComponent = _a.imageComponent;
    var Comma = function (props) { return react.createElement(Icon/* default */.Z, (0,tslib_es6/* __assign */.pi)({ component: CommaIcon }, props)); };
    return (react.createElement(react.Fragment, null,
        react.createElement(LazyImage/* default */.Z, { alt: "testimonial-three-card-image", src: image, classes: "testimonial-three-card-image", imageComponent: imageComponent }),
        react.createElement(Typography/* default */.Z, { weight: "semibold", classes: "testimonial-three-card-name", variant: 'headingTwo' }, name),
        react.createElement(Typography/* default */.Z, { classes: "testimonial-three-card-designation", variant: 'bodyTextOne' }, designation),
        react.createElement("div", { className: "testimonial-three-card-ratings" }, ratings
            ? new Array(ratings)
                .fill(0)
                .map(function (_, index) { return react.createElement("div", { key: index }, "\u2B50"); })
            : null),
        react.createElement(Typography/* default */.Z, { classes: "testimonial-three-card-quote", variant: 'bodyTextOne' }, quote),
        react.createElement("div", { className: "testimonial-three-card-commas" },
            react.createElement(Comma, { className: "testimonial-three-card-comma" }),
            react.createElement(Comma, { className: "testimonial-three-card-comma" }))));
}


//# sourceMappingURL=testimonial-three-card.component.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/swiper/react/swiper.js + 10 modules
var react_swiper = __webpack_require__(29030);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/swiper/react/swiper-slide.js
var swiper_slide = __webpack_require__(22208);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/swiper/core/core.js + 61 modules
var core = __webpack_require__(39569);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/swiper/shared/dom.js
var dom = __webpack_require__(72540);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/swiper/modules/autoplay/autoplay.js
var autoplay = __webpack_require__(52340);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Molecules/CarouselNavigator.js + 1 modules
var CarouselNavigator = __webpack_require__(44826);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Molecules/CarouselProgressIndicator.js
var CarouselProgressIndicator = __webpack_require__(25895);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Organisms/TestimonialThree.js














function TestimonialThree(_a) {
    var classes = _a.classes, testimonials = _a.testimonials;
    var _b = react.useState(0), activeIndex = _b[0], setActiveIndex = _b[1];
    var _c = react.useState(null), swiper = _c[0], setSwiper = _c[1];
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return (react.createElement("div", { className: (0,classnames/* default */.Z)('testimonials-three', classes) },
        react.createElement(Typography/* default */.Z, { variant: 'displayText', classes: 'testimonials-three__title' }, t('landingScreen.testimonialTitle')),
        react.createElement(react_swiper/* Swiper */.t, { spaceBetween: 32, centeredSlides: true, initialSlide: testimonials.length <= 2 ? 0 : 1, onActiveIndexChange: function (s) { return setActiveIndex(s.activeIndex); }, onSwiper: function (s) {
                setSwiper(s);
            }, modules: [autoplay/* default */.Z], autoplay: {
                delay: 3000
            }, breakpoints: {
                0: {
                    slidesPerView: 1
                },
                768: {
                    slidesPerView: testimonials.length < 2 ? 1 : 2
                }
            } }, testimonials.map(function (testimonial, index) { return (react.createElement(swiper_slide/* SwiperSlide */.o, { className: "testimonial-three-card", key: testimonial.name + index },
            react.createElement(TestimonialThreeCard, (0,tslib_es6/* __assign */.pi)({}, testimonial)))); })),
        react.createElement(CarouselProgressIndicator/* default */.Z, { slides: testimonials, position: activeIndex }),
        react.createElement(CarouselNavigator/* default */.Z, { classes: "testimonials-three__navigator", onPrevClick: function () { return swiper.slidePrev(); }, onNextClick: function () { return swiper.slideNext(); } })));
}


//# sourceMappingURL=TestimonialThree.js.map


/***/ }),

/***/ 44536:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TestimonialsOne; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/classnames/index.js
var classnames = __webpack_require__(87637);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Typography.js
var Typography = __webpack_require__(87427);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/swiper/react/swiper.js + 10 modules
var react_swiper = __webpack_require__(29030);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/swiper/react/swiper-slide.js
var swiper_slide = __webpack_require__(22208);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/swiper/core/core.js + 61 modules
var core = __webpack_require__(39569);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/swiper/shared/dom.js
var dom = __webpack_require__(72540);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/swiper/modules/autoplay/autoplay.js
var autoplay = __webpack_require__(52340);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(36929);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/LazyImage.js
var LazyImage = __webpack_require__(93791);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/comma-rounded.icon.js


function CommaRoundedIcon() {
    return (react.createElement("svg", { width: "11", height: "17", viewBox: "0 0 11 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M5.86018 7.54995C5.12044 7.55245 4.3938 7.7453 3.75018 8.10995C4.65633 5.76446 6.15924 3.69623 8.11018 2.10995C8.2218 2.01802 8.31422 1.90501 8.38217 1.77737C8.45012 1.64972 8.49226 1.50995 8.50619 1.36602C8.52012 1.22208 8.50556 1.07682 8.46335 0.938515C8.42114 0.80021 8.3521 0.671573 8.26018 0.55995C8.16825 0.448326 8.05524 0.355901 7.9276 0.287952C7.79995 0.220004 7.66017 0.177863 7.51624 0.163934C7.37231 0.150005 7.22705 0.164562 7.08874 0.206774C6.95044 0.248985 6.8218 0.318024 6.71018 0.409949C2.71018 3.65995 0.930176 8.15995 0.930176 10.95C0.937068 11.9364 1.23105 12.8996 1.77622 13.7218C2.32139 14.544 3.09416 15.1896 4.00018 15.5799C4.58654 15.864 5.22866 16.0143 5.88018 16.0199C6.45364 16.0478 7.02678 15.9589 7.56487 15.7587C8.10295 15.5584 8.59476 15.251 9.01048 14.855C9.42619 14.459 9.75715 13.9827 9.98329 13.455C10.2094 12.9272 10.326 12.3591 10.326 11.7849C10.326 11.2108 10.2094 10.6427 9.98329 10.1149C9.75715 9.5872 9.42619 9.1109 9.01048 8.7149C8.59476 8.3189 8.10295 8.01146 7.56487 7.81121C7.02678 7.61096 6.45364 7.52207 5.88018 7.54995H5.86018Z", fill: "#503E9D" })));
}


//# sourceMappingURL=comma-rounded.icon.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/provider.js
var provider = __webpack_require__(53675);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(21845);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Components/Organisms/TestimonialsOne/Web/testimonial-one-card.component.js








var backgroundImage = function (color) {
    return "\n<svg\n      width=\"336\"\n      height=\"203\"\n      viewBox=\"0 0 336 203\"\n      fill=\"none\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n    >\n      <path\n        d=\"M0 31.7961C40.5 -39 221 111 336 0.0343018V203H0V31.7961Z\"\n        fill=\"".concat(color, "\"\n      />\n    </svg>\n").replace(/\n/g, '');
};
function TestimonialOneCard(_a) {
    var name = _a.name, quote = _a.quote, image = _a.image, designation = _a.designation, imageComponent = _a.imageComponent;
    var theme = (0,react.useContext)(provider/* ThemeContext */.N).theme;
    var Comma = function (props) { return (react.createElement(Icon/* default */.Z, (0,tslib_es6/* __assign */.pi)({ component: CommaRoundedIcon }, props))); };
    return (react.createElement("div", { className: "testimonial-one-card" },
        react.createElement(Typography/* default */.Z, { variant: "bodyTextOne", classes: "testimonial-one-card__description" }, quote),
        react.createElement("div", { style: {
                backgroundImage: "url(\"data:image/svg+xml;utf8,".concat(encodeURIComponent(backgroundImage(theme.colors.primaryColor)), "\")")
            }, className: "testimonial-one-card__user" },
            react.createElement(LazyImage/* default */.Z, { classes: "testimonial-one-card__image", src: image, imageComponent: imageComponent }),
            react.createElement(Typography/* default */.Z, { variant: "headingOne", classes: "testimonial-one-card__name" }, name),
            react.createElement(Typography/* default */.Z, { variant: "bodyTextOneMain", classes: "testimonial-one-card__designation" }, designation)),
        react.createElement("div", { className: "testimonial-one-card__commas__large" },
            react.createElement(Comma, { classes: "testimonial-one-card__comma__large" }),
            react.createElement(Comma, { classes: "testimonial-one-card__comma__large" })),
        react.createElement("div", { className: "testimonial-one-card__commas__small" },
            react.createElement(Comma, { classes: "testimonial-one-card__comma__small" }),
            react.createElement(Comma, { classes: "testimonial-one-card__comma__small" }))));
}


//# sourceMappingURL=testimonial-one-card.component.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Molecules/CarouselProgressIndicator.js
var CarouselProgressIndicator = __webpack_require__(25895);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@ant-design/icons/LeftOutlined.js + 5 modules
var LeftOutlined = __webpack_require__(89315);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@ant-design/icons/RightOutlined.js + 5 modules
var RightOutlined = __webpack_require__(40246);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Organisms/TestimonialsOne.js














function TestimonialsOne(_a) {
    var testimonials = _a.testimonials, classes = _a.classes;
    var _b = react.useState(0), activeIndex = _b[0], setActiveIndex = _b[1];
    var _c = react.useState(null), swiper = _c[0], setSwiper = _c[1];
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return (react.createElement("div", { className: (0,classnames/* default */.Z)('testimonials-one', classes) },
        react.createElement("div", { className: "testimonials-one__content" },
            react.createElement(Typography/* default */.Z, { classes: "testimonials-one__title", variant: 'displayText' }, t('landingScreen.testimonialTitle')),
            react.createElement(react_swiper/* Swiper */.t, { spaceBetween: 32, centeredSlides: true, onActiveIndexChange: function (s) { return setActiveIndex(s.activeIndex); }, initialSlide: testimonials.length <= 2 ? 0 : 1, modules: [autoplay/* default */.Z], autoplay: {
                    delay: 3000
                }, onSwiper: function (s) {
                    setSwiper(s);
                }, breakpoints: {
                    0: {
                        slidesPerView: 1
                    },
                    768: {
                        slidesPerView: testimonials.length < 2 ? 1 : 2
                    }
                } }, testimonials.map(function (testimonial, index) { return (react.createElement(swiper_slide/* SwiperSlide */.o, { key: testimonial.name + index },
                react.createElement(TestimonialOneCard, { key: testimonial.name + index, name: testimonial.name, quote: testimonial.quote, image: testimonial.image, designation: testimonial.designation }))); })),
            testimonials.length > 1 ? (react.createElement(react.Fragment, null,
                react.createElement(CarouselProgressIndicator/* default */.Z, { slides: testimonials, position: activeIndex }),
                react.createElement(LeftOutlined/* default */.Z, { onClick: function () { return swiper.slidePrev(); }, className: "testimonials-left__navigator" }),
                react.createElement(RightOutlined/* default */.Z, { onClick: function () { return swiper.slideNext(); }, className: "testimonials-right__navigator" }))) : null)));
}


//# sourceMappingURL=TestimonialsOne.js.map


/***/ }),

/***/ 91277:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TestimonialsTwo; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87637);
/* harmony import */ var _Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87427);
/* harmony import */ var _Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93791);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26793);
/* harmony import */ var _external_lib_swiper_react_swiper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29030);
/* harmony import */ var _external_lib_swiper_react_swiper_slide_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22208);
/* harmony import */ var _external_lib_swiper_core_core_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39569);
/* harmony import */ var _external_lib_swiper_shared_dom_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72540);
/* harmony import */ var _external_lib_swiper_modules_autoplay_autoplay_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52340);
/* harmony import */ var _Molecules_CarouselNavigator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44826);
/* harmony import */ var _Molecules_CarouselProgressIndicator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(25895);













function TestimonialsTwo(_a) {
    var classes = _a.classes, testimonials = _a.testimonials, imageComponent = _a.imageComponent;
    var _b = react__WEBPACK_IMPORTED_MODULE_0__.useState(0), activeIndex = _b[0], setActiveIndex = _b[1];
    var _c = react__WEBPACK_IMPORTED_MODULE_0__.useState(null), swiper = _c[0], setSwiper = _c[1];
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_11__/* .useTranslation */ .$)().t;
    var renderTestimonialCard = function (user, index) {
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "".concat(index % 2 === 0 ? 'testimonial-card--dark' : 'testimonial-card--light', " testimonial-card") },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { src: user.image, alt: user.name, classes: "testimonial-card__user__image", imageComponent: imageComponent }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { variant: "bodyTextOne", classes: "testimonial-card__user_name" }, user.name),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { variant: "bodyTextOne", classes: "testimonial-card__user_testimonial" }, user.quote)));
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('testimonials-two', classes) },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { classes: "testimonials-two__title", variant: "bodyTextOne" }, t('landingScreen.testimonialTwoTitle')),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_external_lib_swiper_react_swiper_js__WEBPACK_IMPORTED_MODULE_4__/* .Swiper */ .t, { className: "testimonials-carousal-container", spaceBetween: 32, centeredSlides: true, onActiveIndexChange: function (s) { return setActiveIndex(s.activeIndex); }, initialSlide: testimonials.length <= 2 ? 0 : 1, modules: [_external_lib_swiper_modules_autoplay_autoplay_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z], autoplay: {
                delay: 3000
            }, onSwiper: function (s) {
                setSwiper(s);
            }, breakpoints: {
                0: {
                    slidesPerView: 1
                },
                768: {
                    slidesPerView: testimonials.length < 2 ? 1 : 1.4
                }
            } }, testimonials.map(function (user, i) {
            return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_external_lib_swiper_react_swiper_slide_js__WEBPACK_IMPORTED_MODULE_5__/* .SwiperSlide */ .o, null, renderTestimonialCard(user, i));
        })),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Molecules_CarouselProgressIndicator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, { slides: testimonials, position: activeIndex }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Molecules_CarouselNavigator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, { classes: "testimonials-two__navigator", onPrevClick: function () { return swiper.slidePrev(); }, onNextClick: function () { return swiper.slideNext(); } })));
}


//# sourceMappingURL=TestimonialsTwo.js.map


/***/ }),

/***/ 4683:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WhyChooseUsSectionTwo; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87637);
/* harmony import */ var _Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87427);
/* harmony import */ var _Atoms_Button_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66693);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26793);
/* harmony import */ var _Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93791);







function WhyChooseUsSectionTwo(_a) {
    var classes = _a.classes, onReadMore = _a.onReadMore, desc = _a.desc, _b = _a.values, values = _b === void 0 ? [] : _b, title = _a.title, imageComponent = _a.imageComponent;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$)().t;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('why-choose-us-section-two', classes) },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "why-choose-us-section__left" }, values.map(function (value) {
            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { title: value.description, className: "reason-card__container" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { classes: "reason-card__icon", src: value.icon, alt: value.label, imageComponent: imageComponent }),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { variant: "bodyTextOne", classes: "reason-card__title" }, value.label),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { variant: "bodyTextOne", classes: "reason-card__msg" }, value.description)));
        })),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "why-choose-us-section__right" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { classes: "why-choose-us-section-two__title", variant: "displayText", weight: "bold" }, title ? title : t('landingScreen.whyChooseUs')),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { classes: "why-choose-us-section-two__description", variant: "bodyTextOne" }, desc),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Button_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { variant: "solid", classes: "why-choose-us-section-two__cta", onClick: onReadMore, size: "md" }, t('landingScreen.readMore')))));
}


//# sourceMappingURL=WhyChooseUsSectionTwo.js.map


/***/ }),

/***/ 2717:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SearchCtaIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function SearchCtaIcon() {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M13.9999 14L11.0093 11.004M12.6666 7.00004C12.6666 8.50293 12.0696 9.94427 11.0069 11.007C9.94415 12.0697 8.50281 12.6667 6.99992 12.6667C5.49703 12.6667 4.05569 12.0697 2.99298 11.007C1.93027 9.94427 1.33325 8.50293 1.33325 7.00004C1.33325 5.49715 1.93027 4.05581 2.99298 2.9931C4.05569 1.9304 5.49703 1.33337 6.99992 1.33337C8.50281 1.33337 9.94415 1.9304 11.0069 2.9931C12.0696 4.05581 12.6666 5.49715 12.6666 7.00004V7.00004Z", stroke: "#151515", strokeWidth: "1.8", strokeLinecap: "round" })));
}


//# sourceMappingURL=search-cta-icon.icon.js.map


/***/ })

}]);